import React, { useState, useCallback, useEffect } from "react";
import { isVerified, getCountryByCode } from "../../../../../../utils/Helper";
import { BackNextButton, AddButton, Modal, EditCard, Button } from "../../../../../common";
import { EditCardItems } from "../EditCardItems";
import { Search } from "./Search";
import { AddRelatedForm } from "./AddRelatedForm";
import { ReactComponent as Pen } from "../../../../../../assets/images/companyIcons/pen.svg";
import { ReactComponent as MapmarkerIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/mapMarker.svg";
import { ReactComponent as TypeIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/type.svg";
import { ReactComponent as StateIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/stateIcon.svg";
import { ReactComponent as NameIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/name.svg";
import { AddCompanyName } from "./AddCompanyName";
import { useSearchTrevexCompanyQuery, } from "../../../../../../store/search/searchApiSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  useCreateRelatedEntityMutation,
  useCreateRelatedEntityDraftMutation,
  useUpdateRelatedEntityMutation,
  useUpdateRelatedEntityDraftMutation,
  useCreateCompanyMutation,
  useGetCompanyQuery,
  useDeleteRelatedEntityDraftMutation,
  companyApiSlice, useRelatedEntityDraftFetchMutation
} from "../../../../../../store/Company/companyApiSlice";
import { setCurrentEditingCompany } from "../../../../../../store/Company/companySlice";
import useSearchCompany from "../../../../../../Hooks/useSearchCompany";
import { toSentenceCase } from "../../../../../../global_functions/global";
import useCompanyUpdate from "../useCompanyFollowUpdate"
import { ReactComponent as Delete } from "../../../../../../assets/images/companyIcons/delete1.svg"
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";

export const RelatedEntities = ({ onPrev, onNext, onSkip, handleUpdateStatus = () =>{}, compRefetch = () => {} }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showAddCompany, setShowAddCompany] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState();
  const [companyData, setCompanyData] = useState();
  const [related, setRelatedEntities] = useState([]);
  const [relatedDraft, setRelatedEntitiesDraft] = useState([]);
  const [editRelatedEntities, setEditRelatedEntities] = useState(null);
  const [RelatedEntityDraft] = useRelatedEntityDraftFetchMutation();
  const [editType, setEditType] = useState("");
  const [countryCodeSearch, setCountryCodeSearch] = useState("");
  const [dataChanged, setDataChanged] = useState(false);

  function searchCompany(fn, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        fn.apply(context, args);
      }, wait);
    };
  }

  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);

  const [createRelatedEntity, { isLoading: creating }] = useCreateRelatedEntityMutation();

  const [createRelatedEntityDraft, { isLoading: creatingDraft }] = useCreateRelatedEntityDraftMutation();

  const [updateRelatedEntity, { isLoading: isCreating }] = useUpdateRelatedEntityMutation();

  const [updateRelatedEntityDraft, { isLoading: isCreatingDraft }] = useUpdateRelatedEntityDraftMutation();
  const [deleteDraft] = useDeleteRelatedEntityDraftMutation()
  const [createCompany, { isLoading: companyCreating }] = useCreateCompanyMutation();

  const searchOnChange = useCallback(searchCompany(setSearchQuery, 400), []);

  const { worldBoxToken } = useSelector((state) => state.search);

  const handleUpdateCompany = useCompanyUpdate();
  const { data, isLoading, error, message } = useSearchCompany(
    searchQuery,
    countryCodeSearch,
    token,
    worldBoxToken
  );

  useEffect(() => {
    if (data) {
      setSearchResults(data);
    }
  }, [data, dataChanged]);

  const { data: updatedCompanyData, refetch } = useGetCompanyQuery({
    companyId: currentEditingCompany?.companyID,
    token,
  });
  useEffect(() => {
    if (updatedCompanyData) {
      dispatch(setCurrentEditingCompany(updatedCompanyData));
    }
  }, [updatedCompanyData, dispatch, dataChanged]);
  useEffect(() => {
    if (!currentEditingCompany) return;
    let resultArr = [];
    let Dettemp = currentEditingCompany?.relatedEntity?.forEach(function (obj) {
      if (obj?.related_entityID?.is_deleted == 0) {
        resultArr.push(obj)
      }
    });
    setRelatedEntities(resultArr);

    companyStatus();
  }, [currentEditingCompany, dataChanged]);

  const companyStatus = async () => {

    let dataval = await RelatedEntityDraft({
      companyID: currentEditingCompany?.companyID,
      token,
    });
    if (dataval?.data?.data) {
      let respData = dataval?.data?.data;
      let tempArr = [];
      let draft_ids = [];
      let ids = [];
      let main_ids = [];
      for (let i = 0; i < respData.length; i++) {
        draft_ids.push(respData[i]?.related_entityID_id);
        tempArr.push(respData[i]);
      }
      currentEditingCompany?.relatedEntity?.forEach(function (obj) {
        if (obj?.related_entityID?.is_deleted == 0) {
          ids.push(obj?.related_entityID?.related_entityID)
        }
      });
      ids.forEach(function (id) {
        if (!draft_ids.includes(id))
          main_ids.push(id)
      });
      currentEditingCompany?.relatedEntity?.forEach(function (obj) {
        if (obj?.related_entityID?.is_deleted == 0) {
          if (main_ids.includes(obj?.related_entityID?.related_entityID)) {
            tempArr.push(obj?.related_entityID)
          }
        }
      });
      setRelatedEntitiesDraft(await Promise.all(tempArr))
    }

  }
  const modalHandle = (related_entityID, type) => {
    setEditType(type);
    setIsOpen(!isOpen);
    setSearchResults(null);

    if (type == "edit") {
      setSelectedCompany({ name: related_entityID?.companyID?.registered_company_name });
    } else {
      setSelectedCompany(null);
    }

    setSearchQuery("");
    setEditRelatedEntities(related_entityID);
  };

  const handleAddNewCompany = () => {
    setShowAddCompany((prev) => !prev);
    setShowSearch((prev) => !prev);
    setSearchResults(null);
    setSelectedCompany(null);
    setSearchQuery("");
  };

  const handleSearchShow = () => {
    setShowSearch((prev) => !prev);
    setShowForm((prev) => !prev);
  };
  const handleFormShow = (companyData) => {
    if (selectedCompany || companyData) {
      setShowSearch(false);
      setShowForm(true);
      setShowAddCompany(false);
    }
  };
  const handleSearch = ({ searchTerm, countryCode }) => {
    if (searchTerm.length < 3) {
      setSearchResults([]);
    }
    if (searchTerm.length >= 3) {
      setCountryCodeSearch(countryCode);
      searchOnChange(searchTerm);
    }
  };
  const getSelectedCompany = (company) => {
    setSelectedCompany(company);
  };

  const verifiedData = currentEditingCompany.verifiedCompany;

  const handleRelatedSubmit = async (companyData) => {
    if (isVerified(verifiedData)) {
      if (editType === "edit") {
        try {
          if (editRelatedEntities?.related_entity_draftID) {
            const CompanyId = editRelatedEntities?.companyID?.companyID;
            if (editRelatedEntities?.related_entityID_id != undefined && editRelatedEntities?.related_entityID_id != null) {
              const res = await updateRelatedEntityDraft({
                related_entityId: editRelatedEntities?.related_entity_draftID,
                data: {
                  current_companyID: currentEditingCompany.companyID,
                  relation_type: companyData.relation_type,
                  country: companyData?.country,
                  state: companyData?.state,
                  companyID: CompanyId,
                  request_type: "Related Entities update draft request",
                  related_entityID: editRelatedEntities?.related_entityID,
                },
                token,
              }).unwrap();
              if (res) {

                // window.location.reload();
              }
            } else {
              const res = await updateRelatedEntityDraft({
                related_entityId: editRelatedEntities?.related_entity_draftID,
                data: {
                  current_companyID: currentEditingCompany.companyID,
                  relation_type: companyData.relation_type,
                  country: companyData?.country,
                  state: companyData?.state,
                  companyID: CompanyId,
                  request_type: "Related Entities update draft request",
                },
                token,
              }).unwrap();
              if (res) {
                compRefetch();
                refetch()
                setDataChanged(!dataChanged);
              }
            }

          } else {
            let dataCompany = "";
            if (!companyData.trevex_id && companyData.win) {
              dataCompany = await createCompany({
                data: {
                  wb_win: companyData.win,
                  registered_company_name: companyData.name,
                  country_code: companyData.country,
                },
                token,
              }).unwrap();
            }
            const res = await createRelatedEntityDraft({
              data: {
                current_companyID: currentEditingCompany.companyID,
                relation_type: companyData.relation_type,
                country: companyData?.country,
                state: companyData?.state,
                companyID: dataCompany?.data?.companyID || companyData?.companyID,
                request_type: "Related Entities create draft request",
                registered_company_name: companyData.name,
                related_entityID: editRelatedEntities?.related_entityID,
              },
              token,
            }).unwrap();
            if (res) {
              compRefetch();
              refetch()
              setDataChanged(!dataChanged);
            }
          }

        } catch (error) {
        } finally {
          modalHandle();
        }
      } else {
        try {
          let dataCompany = "";
          if (!companyData.trevex_id && companyData.win) {
            dataCompany = await createCompany({
              data: {
                wb_win: companyData.win,
                registered_company_name: companyData.name || selectedCompany.name,
                country_code: companyData.country,
              },
              token,
            }).unwrap();
          }
          const res = await createRelatedEntityDraft({
            data: {
              current_companyID: currentEditingCompany.companyID,
              relation_type: companyData.relation_type,
              country: companyData?.country,
              state: companyData?.state,
              companyID: dataCompany?.data?.companyID || companyData?.trevex_id || companyData?.companyID,
              request_type: "Related Entities create draft request",
              registered_company_name: companyData.name,
            },
            token,
          }).unwrap();
          if (res) {
            compRefetch();
            refetch()
            setDataChanged(!dataChanged);
          }

        } catch (error) {
        } finally {
          modalHandle();
        }
      }
    } else {
      if (editType === "edit") {
        try {
          const CompanyId = editRelatedEntities?.companyID?.companyID;
          const res = await updateRelatedEntity({
            token,
            related_entityId: editRelatedEntities?.related_entityID,

            data: {
              current_companyID: currentEditingCompany.companyID,
              company_name: editRelatedEntities?.companyID?.registered_company_name,
              relation_type: companyData?.relation_type,
              country: companyData?.country,
              state: companyData?.state,
              comapnyID: CompanyId,
              registered_company_name: companyData.name,

            },
          });

          if (res) {
            refetch();
            const result = await handleUpdateCompany(currentEditingCompany.companyID, "Related Entity Updated", token);
            if (!result.success) {
              console.error(result.error);
            }
            if (result) {
              compRefetch();
              refetch()
              setDataChanged(!dataChanged);
            }
          }
        } catch (error) {
        } finally {
          modalHandle();
        }
      } else {
        let ram = "";
        if (!companyData?.trevex_id && (companyData?.wb_win || companyData?.win)) {
          ram = await createCompany({
            data: {
              wb_win: companyData?.wb_win || companyData?.win,
              registered_company_name: companyData.name || selectedCompany.name,
              country_code: companyData.country,
            },
            token,
          }).unwrap();
        }
        const res = await createRelatedEntity({
          data: {
            current_companyID: currentEditingCompany.companyID,
            relation_type: companyData.relation_type,
            country: companyData?.country,
            state: companyData?.state,
            companyName: (ram?.data?.registered_company_name || companyData.name),
            companyID: ram?.data?.companyID || companyData.companyID || companyData.trevex_id,
          },
          token,
        }).unwrap();
        if (res) {
          refetch();
          modalHandle();
          const result = await handleUpdateCompany(currentEditingCompany.companyID, "New Related Entity Added", token);
          if (!result.success) {
            console.error(result.error);
          }
          if (result) {
            compRefetch();
            refetch()
            setDataChanged(!dataChanged);
          }
        }
      }
    }
  };

  function createArrayFromObject(object) {
    let otherData = ["company", "relation_type", "state", "country"];
    let icons = {
      company: <NameIcon />,
      country: <MapmarkerIcon />,
      state: <StateIcon />,
      relation_type: <TypeIcon />,
    };
    let companyName;
    if (object?.companyID?.registered_company_name) {
      companyName = object?.companyID?.registered_company_name;
    } else if(object?.registered_company_name) {
      companyName = object?.registered_company_name;
    }else if(object?.companyName){
      companyName = object?.companyName
    }
    const newObject = {
      related_entityID: object?.related_entityID,
      relation_type: toSentenceCase((object?.relation_type || '').replace(/_/g, " ")),
      company: companyName,
      state: object?.state,
      country: getCountryByCode(object?.country),
    };

    let data = [];

    for (let key in newObject) {
      if (otherData.includes(key)) {
        data.push({ [key]: newObject[key], icon: icons[key] });
      }
    }


    let keyValuePairs = data.map((item) => Object.entries(item).map(([key, value]) => [key, value]));

    let html = keyValuePairs.map((item) => <EditCardItems heading={item[0][0]?.replaceAll("_", " ")} subHeading={item[0][1]?.replace("|", "")} icon={item[1][1]} />);
    return html;
  }
  const modalHandleDelete = async (deleteInfo) => {
    if (deleteInfo?.related_entity_draftID) {
      let dataval = await deleteDraft({
        data: deleteInfo?.related_entity_draftID,
      });
      if (dataval?.data == null) {
        alert("Related Entities Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
      }
    } else if (deleteInfo?.related_entityID) {
      let res = await updateRelatedEntity({
        data: { is_deleted: 1 },
        related_entityId: deleteInfo?.related_entityID,
        token,
      }).unwrap();
      if (res?.is_deleted == 1) {
        handleUpdateStatus()
        alert("Related Entities Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
      }
    }
  }
  return (
    <div className="mt-5 mr-20">
      {isOpen && (
        <Modal modalHandle={modalHandle}>
          {showForm && (
            <AddRelatedForm
              title="Add Related Entities"
              onSearch={handleSearchShow}
              selectedCompany={selectedCompany}
              showForm={handleFormShow}
              handleRelatedSubmit={handleRelatedSubmit}
              isLoading={creating || isCreating || creatingDraft}
              editRelatedEntities={editRelatedEntities}
              from="relatedEntity"
            />
          )}
          {showSearch && (
            <Search
              onSearch={handleSearch}
              results={searchResults}
              isLoading={isLoading}
              label={"Select Country"}
              getSelectedCompany={getSelectedCompany}
              showForm={handleFormShow}
              handleSearchShow={handleSearchShow}
              handleAddNewCompany={handleAddNewCompany}
              breadPrev="Add related entities"
              breadNext="Select Company"
              searchLabel="Search Company"
              searchEmptyText="Search & Select your company"
              error={error}
              message={message}
            />
          )}
          {showAddCompany && (
            <AddCompanyName
              handleAddNewCompany={handleAddNewCompany}
              handleCompanySubmit={handleFormShow}
              breadNext={"Add Company Name"}
              breadPrev={"Select company"}
              label={"Add Company Name"}
              handleSelectedCompany ={getSelectedCompany}
              isLoading={creating || isCreating || isCreatingDraft}
            />
          )}
        </Modal>
      )}
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">Related Entities</h3>

      <div className="border border-slate rounded-lg p-8 mb-6">
        <AddButton text="Add Related Entities" buttonText="Add" onClick={() => modalHandle(null)} />
        <div className="grid grid-cols-2 gap-4">
          {relatedDraft.length <= 0 && related?.map((item) => (
            <EditCard>
              <div className="statusSection">
                {item.related_entityID.status === "Verified" && (
                  <Verified />
                )}
                {item.related_entityID.status === "Declined" && (
                  <Declined />
                )}
                {item.related_entityID.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.related_entityID?.status === "Requested" || item?.related_entityID?.status === "raised" || item?.related_entityID?.status === "pending") && (
                  <Requested />
                )}
              </div>
              <div className="h-[17rem] overflow-y-auto relative  my-2">{createArrayFromObject(item?.related_entityID)}</div>
              <div className="actionseditDelete  gap-4">
                <Button
                  onClick={() => modalHandle(item?.related_entityID, "edit")}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative">
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                <Button
                  onClick={() => modalHandleDelete(item?.related_entityID)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>
            </EditCard>
          ))}
          {relatedDraft?.map((item) => (
            <EditCard>
              <div className="statusSection">
                {item.status === "Verified" && (
                  <Verified />
                )}
                {item.status === "Declined" && (
                  <Declined />
                )}
                {item.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.status === "Requested" || item?.status === "raised" || item?.status === "pending") && (
                  <Requested />
                )}
              </div>
              <div className="h-[17rem] overflow-y-auto relative  my-2">{createArrayFromObject(item)}</div>
              <div className="actionseditDelete  gap-4">

                <Button
                  onClick={() => modalHandle(item, "edit")}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative">
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                <Button
                  onClick={() => modalHandleDelete(item)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>
            </EditCard>
          ))}
        </div>
      </div>

      <BackNextButton onPrev={() => onPrev(4, "Key Personnel", "Details")}
        onNext={() => onNext(6, "Business Relation", "Details")} onSkip={() => onSkip(6, "Business Relation", "Details")} />
    </div>
  );
};
